import {
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import { AuthService, UserService } from 'src/app/api/dynamic-form/services';
import { LocalStorageService } from '../../shared/services/local-storage.service';
import {
  LoginApiResponse,
  UserProfileDto,
} from 'src/app/api/dynamic-form/models';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RedirectService } from 'src/app/shared/services/redirect-service';
import { CONSTANTS } from 'src/app/shared/constants/constant';

import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatButtonModule],
})
export class LoginComponent implements OnInit, OnDestroy {
  @HostBinding('class') class = 'w-100';
  public loginForm!: UntypedFormGroup;
  public isAuthLoading = false;
  constants = CONSTANTS;
  loggedInUser: UserProfileDto = {};
  constructor(
    private renderer: Renderer2,
    private toastr: ToastrService,
    private authService: AuthService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private redirectService: RedirectService,
    private userService: UserService
  ) {}
  ngOnInit() {
    this.renderer.addClass(document.querySelector('app-root'), 'login-page');
    this.loginForm = new UntypedFormGroup({
      email: new UntypedFormControl(null, Validators.required),
      password: new UntypedFormControl(null, Validators.required),
    });
  }
  fetchLoggedInUser() {
    this.userService.getLoggedInUserDetails().subscribe({
      next: user => {
        if (user?.data) {
          this.loggedInUser = user?.data[0] || {};

          this.redirectService.setPermissions(
            (this.loggedInUser as any).Privileges || []
          );
          this.router.navigate(['/']);
          this.isAuthLoading = false;
        }
      },
      error: error => {
        this.isAuthLoading = false;
        this.toastr.error(error?.error?.message);
      },
    });
  }

  loginByAuth() {
    if (this.loginForm.valid) {
      this.isAuthLoading = true;
      const payload = {
        body: {
          username: this.loginForm.value.email,
          password: this.loginForm.value.password,
        },
      };
      this.authService.passwordLogin(payload).subscribe(
        (res: LoginApiResponse) => {
          if (res.code === 200) {
            this.toastr.success(res.message);
            const token = res.data ? (res.data[0].accessToken as string) : '';
            const refresh = res.data
              ? (res.data[0].refershToken as string)
              : '';
            this.localStorageService.setItem('token', token);
            this.localStorageService.setItem('refreshToken', refresh);
            this.fetchLoggedInUser();
          }
        },
        error => {
          this.isAuthLoading = false;
          if (error?.error?.message) {
            this.toastr.error(error?.error?.message);
          }
        }
      );
    } else {
      this.toastr.error('Credentials not found!');
    }
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.querySelector('app-root'), 'login-page');
  }
}
